import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { MY_PARTY_QUERY_KEY } from '../api/queryKeys.js';

export const useMyPartyInvalidation = (): (() => void) => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: MY_PARTY_QUERY_KEY });
  }, [queryClient]);
};
